import ModuleContext from 'CMFW/context/ModuleContext';
import { LoadingItem } from 'CMFW/layout/Loading';
import { CardHeader, CardId } from 'components/common/styles';
import { IRefIds } from 'constants/refs';
import { useForceRender } from 'hooks/useForceRender';
import CompoundCardModel from 'models/CompoundCardModel';
import React, { useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { tabsOpened } from 'store/actions/tabs';
import styled from 'styled-components';
import { ICompoundEdit } from 'models/CompoundModel';
import VocCard from './VocCard';
import PanelCard from './PanelCard';

type IProps = {
  id: number;
};

const CompoundCard: React.FC<IProps> = (props) => {
  const { id } = props;

  const forceRender = useForceRender();
  const dispatch = useDispatch();
  const moduleModel = useContext(ModuleContext);

  const compoundCardModel = useMemo(() => new CompoundCardModel({ render: forceRender, compoundId: id }), [
    forceRender,
    id,
  ]);

  const cardData = compoundCardModel.getItemValue('cardData') as ICompoundEdit | undefined;

  const handleIdClick = () => {
    dispatch(
      tabsOpened({
        refId: IRefIds.compounds,
        search: id.toString(),
        courseId: moduleModel.courseId,
      }),
    );
  };

  if (!cardData || !cardData.items) {
    return null;
  }

  // Sort items by order
  const sortedItems = [...cardData.items].sort((a, b) => a.order - b.order);

  return (
    <ModuleContext.Provider value={compoundCardModel}>
      <CompoundCardContainer key={id}>
        <CardHeader>
          <CardId onClick={handleIdClick}>{id}</CardId>
          <Title>{cardData.title}</Title>
        </CardHeader>
        <ItemsContainer>
          {sortedItems.map((item, index) => {
            const isLast = index === sortedItems.length - 1;
            
            return (
              <React.Fragment key={`${item.ref}-${item.refId}`}>
                {item.ref === IRefIds.vocs && (
                  <ModuleContext.Provider value={{ courseId: moduleModel.courseId } as any}>
                    <VocCard id={item.refId} />
                  </ModuleContext.Provider>
                )}
                {item.ref === IRefIds.panels && (
                  <ModuleContext.Provider value={{ courseId: moduleModel.courseId } as any}>
                    <PanelCard id={item.refId} />
                  </ModuleContext.Provider>
                )}
                {!isLast && <PlusSign>+</PlusSign>}
              </React.Fragment>
            );
          })}
        </ItemsContainer>
        <LoadingItem />
      </CompoundCardContainer>
    </ModuleContext.Provider>
  );
};

const CompoundCardContainer = styled.div`
  display: inline-block;
  min-height: 100px;
  border: solid 1px #b9b9b9;
  border-radius: 0 4px 0 4px;
  margin: 5px;
  padding: 0;
  background-color: white;
  position: relative;
  vertical-align: top;
`;

const Title = styled.div`
  margin: 2px;
  font-size: 16px;
  font-weight: 600;
  flex: 1;
`;

const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 8px 2px;
`;

const PlusSign = styled.div`
  text-align: center;
  color: #666;
  font-size: 16px;
  font-weight: bold;
  padding: 2px 0;
  line-height: 1;
`;

export default CompoundCard;